import { RELATIONSHIP_ROW_Y_PADDING } from "../../constants";
import { immutableRecords } from "../../types";
const getTableData = (itemsById, rows, expandedItems) => {
  let top = 0;
  let width = 0;

  const mergedRows = rows.map((itemDisplay, index) => {
    const height = itemDisplay.itemCardSize.height + 2 * RELATIONSHIP_ROW_Y_PADDING;

    width = Math.max(itemDisplay.itemCardSize.width, width);

    const rect = immutableRecords.FlatRectRecord({
      top,
      height,
      left: 0,
      width: width,
      right: width,
      bottom: top + height
    });

    top += height;
    return immutableRecords.ItemCardDisplayRecord({
      itemDisplay: itemDisplay.set("index", index),
      rect,
      indentationLevel: itemDisplay.superDepth,
      hasChildren: itemDisplay.children.size > 0,
      childrenExpanded: expandedItems.contains(itemDisplay.id)
    });
  });
  return immutableRecords.ItemCardListDisplayRecord({
    rows: mergedRows,
    width: width,
    height: top
  });
};

export default {
  getTableData
};
